export default {
    title: 'Unesite podatke o podsetniku',
    create_reminder: 'Kreiraj podsetnik',
    row_title: 'Naziv',
    message: 'Poruka',
    show_reservation_time: 'Prikaži vreme termina u poruci',
    send_before: 'Vreme slanja pre rezervacije',
    type: 'Tip',
    services: 'Usluge',
    active: 'Aktivno',
    action: 'Akcije',
    usage: 'Potrošnja',
    price: 'Cena RSD',
    price_bam: 'Cena BAM',
    chose_type: 'Izaberite tip podsetnika',
    info_reminder_before_minutes: 'Vreme slanja može da odstupa +/- 15 minuta',
    info_reminder_before_minutes_now: 'Slanje odmah u slučaju da je rezervacija za manje od 30 minuta',
    show_time_example: 'Prikaži vreme termina u poruci (primer 12.12.2024 18:00-19:00)',
    totalPrice: 'Ukupna potrošnja',
    totalSmsPrice: 'SMS potrošnja',
    totalSmsCount: 'Broj SMS poruka',
    totalEmailPrice: 'Email potrošnja',
    totalEmailCount: 'Broj Email poruka',
    pdv_message: 'Cene su prikazane bez PDV-a',
    pdv_include_message: '* uračunat PDV',
    select_offers_msg: 'Molimo izaberite usluge',
    select_remind_before_msg: 'Molimo izaberite vreme slanja pre rezervacije',
    info_modal: {
        title: 'Informacije o podsetnicima',
        text: '<h3>Informacije o servisu</h3> <p>Molimo vas da obratite pažnju na sledeće uslove i pravila korišćenja usluga slanja SMS i email podsetnika:</p> <ul> <li>Cena jedne SMS poruke iznosi <b>{n}</b>.</li> <li>Ukupan broj SMS poruka zavisi od broja karaktera unetih u tekst poruke.</li> <li>Broj karaktera je manji za tekstove na ćirilici ili latinici nego kod engleskog alfabeta.</li> <li>Ukupna cena podsetnika biće prikazana ispod poruke podsetnika.</li> <li>Cena slanja email poruke je fiksna i iznosi <b>{m}</b>.</li> <li>Svaki podsetnik mora biti aktiviran od strane Bookeraj tima.</li> <li>Bićete kontaktirani u roku od <b>48 sati</b> od kreiranja podsetnika radi potvrde.</li> <li>Za sva pitanja možete nas kontaktirati na email bookeraj&#64;codebuste.rs</li> <li>Slanje podsetnika može varirati u vremenskom intervalu od -15 minuta do +15 minuta u odnosu na izabrano vreme.</li> </ul>',
        price: 'bez PDV-a',
    },
}
